export default {
  OPPORTUNITIES: 'opportunities',
  OPPORTUNITY: 'opportunity',
};
